(function () {
  // Only run if IntersectionObserver exists
  if (!("IntersectionObserver" in window)) return;

  function init() {
    // Find video icons in product thumbs
    var icons = document.querySelectorAll('.product__thumb .icon.icon-media-video');
    if (!icons.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var thumb = entry.target.closest('.product__thumb');
        if (!thumb) return;

        if (entry.isIntersecting) {
          thumb.classList.add('ms-video-thumb-inview');
        } else {
          thumb.classList.remove('ms-video-thumb-inview');
        }
      });
    }, {
      root: null,
      threshold: 0.65 // mostly on screen before pulsing
    });

    icons.forEach(function (icon) {
      io.observe(icon);
    });
  }

  // Run now + after theme sections load (Broadcast uses section rendering)
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
